import { DEFAULT_GRAPHIC_SCALE } from '@/constants';
export var convertPercentToValue = function (percent) {
    var value = (DEFAULT_GRAPHIC_SCALE * percent) / 100;
    return value;
};
export var convertValueToPercent = function (value) {
    var data = +((value * 100) / DEFAULT_GRAPHIC_SCALE).toFixed(2);
    var percent = Math.round((data * 100) / 100);
    if (percent > 100) {
        return 100;
    }
    return percent;
};
